import { SkipLink as BrSkipLink } from "@vwfs-bronson/bronson-react";

interface Props {
  id: string;
}

export const SkipLink = ({ id }: Props) => {
  return <BrSkipLink href={`#${id}`} label="Zum Hauptinhalt springen" />;
};
